import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { isOrNotConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import PriorityDropdown from 'components/UI/PriorityDropdown/PriorityDropdown';

const TaskPriorityFilter = ({ index }) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              options={isOrNotConditionOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Select Condition"
              className="w-100"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <PriorityDropdown
              value={field.value?.priority || ''}
              onChange={(e) => field.onChange({ priority: e.value })}
              placeholder="Select Value"
              className="input-shadow w-100"
              display="chip"
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default TaskPriorityFilter;
